import { useEffect } from "react";
import { motion } from "framer-motion";
import { Star, Sparkles, ArrowRight } from "lucide-react";
import "./ClientTestimonies.css";
import {
    MD, tomV, ronny, MujbourR, deniserai, dwight, frankie, ronnynilesen, StephenThomas, arvinpic, wisr,
    hkm, hayysoft, leadX, LGB, improve, sprotly, dataScal
} from "../../../theme/images";
import { Link } from "react-router-dom";
const fadeUp = {
    hidden: { opacity: 0, y: 60 },
    visible: (i = 0) => ({
        opacity: 1,
        y: 0,
        transition: {
            delay: i * 0.08,
            duration: 0.7,
            ease: [0.25, 0.46, 0.45, 0.94]
        },
    }),
};

const container = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: { staggerChildren: 0.1 }
    }
};

const testimonials = [
    {
        name: "Rune Johannessen",
        role: "Co-Founder, Norgate AS",
        quote:
            "I'm Rune Johannessen, co-founder of Norgate AS with Arvin Johannessen. We're developing Wisr, an app to revolutionize professional advisor connections using AI. SpringUp Labs has been crucial to our progress, showing exceptional flexibility and communication. We highly recommend them for outstanding project support.",
        avatar: ronny,
        brand: wisr,
    },
    {
        name: "Markus Doetsch",
        role: "CEO, Henekingmedia Germany",
        quote:
            "For business reasons we decided to build an offshore model and SpringUp Labs team helped us to scale quickly and started the product engineering efforts within the first month. Through a quality-driven approach they were able to help in our product journey.",
        avatar: MD,
        brand: hkm,
    },
    {
        name: "Mujbour Rahman",
        role: "Managing Director, Hayysoft Systems",
        quote:
            "When I conceived the Hayysoft Platform, SpringUp Lab's expertise with product start-ups expedited our launch and market entry. Their remarkable ability to grasp requirements and convert them into code, coupled with meticulous attention to detail and efficiency under tight schedules, continues to impress me.",
        avatar: MujbourR,
        brand: hayysoft,
    },
    {
        name: "Tom Vito",
        role: "Founder & CEO, LeadX",
        quote:
            "SpringUp Labs team helped me immensely in LeadX platform development, but also helped us in introducing customers in the India geography. The team always works towards a win-win situation.",
        avatar: tomV,
        brand: leadX,
    },
    {
        name: "Arvin Johannessen",
        role: "Co-Founder, Norgate AS",
        quote:
            "I'm Arvin Johannessen, co-founder of Norgate AS. We're developing Wisr, an app transforming advisor connections with AI. SpringUp Labs has been crucial, showing great adaptability and excellent communication. I highly recommend them for outstanding project support.",
        avatar: arvinpic,
        brand: wisr,
    },
    {
        name: "Frankie Bashan",
        role: "Founder, Little Gay Book",
        quote:
            "SpringUp Labs has been pivotal in resolving our app's software issues and improving its performance. Their expertise and proactive approach have restored our confidence and allowed us to focus on our core mission of connecting people. We highly recommend them for their exceptional DevOps services.",
        avatar: frankie,
        brand: LGB,
    },
    {
        name: "Dwight Harris Jr",
        role: "Chief Executive, DataScalp",
        quote:
            "SpringUp Labs has simply been the perfect partner for us since 2018. They have successfully implemented every concept from idea to realization. Consequently, we have significantly broadened our global business and are having serious discussions with investors from businesses created through SpringUp Labs.",
        avatar: dwight,
        brand: dataScal,
    },
    {
        name: "Denise Rai",
        role: "Client Services Director",
        quote:
            "SpringUp Labs significantly improved our app's performance and resolved critical software issues with their proactive expertise. Their DevOps services are exceptional, making them highly recommended for any organization seeking operational efficiency and growth.",
        avatar: deniserai,
        brand: LGB,
    },
    {
        name: "Ronny A. Nilsen",
        role: "CEO & Founder",
        quote:
            "Improve Performance International (Oslo) and SpringUp Labs (Pune) joined forces to recruit a Senior Developer for Solintegra's solar-roof software project. Their collaboration led to the successful placement of a candidate with the right skills and expertise, demonstrating the effectiveness of their recruitment and implementation process. ",
        avatar: ronnynilesen,
        brand: improve,
    },
    {
        name: "Stephen Thomas",
        role: "Chief Operating Officer, Sprotly",
        quote:
            "Working with Santosh and his team at SpringUp Labs has been fantastic! I have been delighted with their dedication and determination towards the success of the projects they have worked on. They have shown themselves to be both friendly and professional which has made working with them a wonderful experience.",
        avatar: StephenThomas,
        brand: sprotly,
    },
];

const ClientTestimonies = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="ct-page">

            {/* HERO - With Animation */}
            <section className="ct-hero">
                <div className="ct-grid-bg" />
                <div className="ct-blob b1" />
                <div className="ct-blob b2" />
                <div className="ct-blob b3" />

                <motion.div
                    className="ct-hero-inner"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={fadeUp}
                >
                    <motion.span
                        className="ct-eyebrow"
                        custom={0}
                        variants={fadeUp}
                    >
                        <span className="dot" />
                        <Sparkles size={14} /> Client Stories
                    </motion.span>

                    <motion.h1
                        className="ct-title"
                        custom={1}
                        variants={fadeUp}
                    >
                        What Our <span className="ct-grad">Clients</span>
                        <br />
                        Are Saying <span className="ct-underline">About Us</span>
                    </motion.h1>

                    <motion.p
                        className="ct-sub"
                        custom={2}
                        variants={fadeUp}
                    >
                        Discover how our clients have benefited from partnering with us, as they share
                        their experiences and the exceptional value we've delivered across every project.
                    </motion.p>
                </motion.div>
            </section>

            {/* TESTIMONIALS SECTION */}
            <section className="ct-section">
                <motion.div
                    className="ct-section-head"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={fadeUp}
                >
                    <h2>Clients Testimonial</h2>
                    <p>Real words from real partners we've built lasting relationships with.</p>
                </motion.div>

                <motion.div
                    className="ct-grid"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-50px" }}
                    variants={container}
                >
                    {testimonials.map((t, i) => (
                        <motion.article
                            key={i}
                            className="ct-card"
                            custom={i}
                            variants={fadeUp}
                            whileInView="visible"
                            initial="hidden"
                            viewport={{ once: true, margin: "-80px" }}
                            whileHover={{ y: -8, transition: { duration: 0.3 } }}
                        >
                            <div className="ct-avatar-wrap">
                                <img src={t.avatar} alt={t.name} className="ct-avatar" loading="lazy" />
                            </div>
                            <span className="ct-quote-glyph">"</span>

                            <h3 className="ct-name">{t.name}</h3>
                            <p className="ct-role">{t.role}</p>
                            <div className="ct-divider" />
                            <p className="ct-text ">{t.quote}</p>

                            <div className="ct-card-foot">
                                <div className="ct-stars" aria-label="5 star rating">
                                    {Array.from({ length: 5 }).map((_, j) => (
                                        <Star key={j} size={15} fill="currentColor" strokeWidth={0} />
                                    ))}
                                </div>
                                <img
                                    src={t.brand}
                                    alt={`${t.brand} logo`}
                                    loading="lazy"
                                    style={{ width: "5rem", height: "5rem" }}
                                />
                            </div>
                        </motion.article>
                    ))}
                </motion.div>

                <div className="ct-cta container">
                    <h3>Ready to write the next success story?</h3>
                    <p>Join the growing list of partners who've transformed their products with us.</p>
                    <Link to="/contact" className="ct-cta-btn">
                        Start a Conversation <ArrowRight size={18} />
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default ClientTestimonies;